// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { WarmupEitherEditForm, WeeklyEmailPushFrequency, Language, WarmupEditForm } from "../schema";

export function serialize_WarmupEditForm(obj: WarmupEditForm): string {
  const serialized = ((value: { either: WarmupEitherEditForm }): unknown => {
    return {
      either: ((
        value:
          | {
              kind: "SSO";
              corporateId: bigint;
              countryCode: string;
              email: string;
              evrUuid: string;
              extraField1: string;
              extraField2: string;
              extraField3: string;
              firstName: string;
              frequency: WeeklyEmailPushFrequency;
              function: string | null;
              language: Language;
              lastName: string;
              password: string;
              ssoNameId: string;
              termsAndConditions: boolean;
              title: bigint | null;
              town: string | null;
            }
          | {
              kind: "B2B";
              corporateId: bigint;
              countryCode: string;
              email: string;
              evrUuid: string;
              extraField1: string;
              extraField2: string;
              extraField3: string;
              firstName: string;
              frequency: WeeklyEmailPushFrequency;
              language: Language;
              lastName: string;
              password: string;
              termsAndConditions: boolean;
            }
          | {
              kind: "TRIAL";
              corporateId: bigint;
              countryCode: string;
              email: string;
              evrUuid: string;
              firstName: string;
              frequency: WeeklyEmailPushFrequency;
              language: Language;
              lastName: string;
              password: string;
              termsAndConditions: boolean;
            }
          | {
              kind: "B2C";
              corporateId: bigint;
              countryCode: string;
              email: string;
              evrUuid: string;
              firstName: string;
              frequency: WeeklyEmailPushFrequency;
              language: Language;
              lastName: string;
              password: string;
              termsAndConditions: boolean;
            },
      ): unknown => {
        switch (value.kind) {
          case "SSO": {
            return {
              kind: "SSO",
              corporateId: ((value: bigint): unknown => {
                return value;
              })(value["corporateId"]),
              countryCode: ((value: string): unknown => {
                return value;
              })(value["countryCode"]),
              email: ((value: string): unknown => {
                return value;
              })(value["email"]),
              evrUuid: ((value: string): unknown => {
                return value;
              })(value["evrUuid"]),
              extraField1: ((value: string): unknown => {
                return value;
              })(value["extraField1"]),
              extraField2: ((value: string): unknown => {
                return value;
              })(value["extraField2"]),
              extraField3: ((value: string): unknown => {
                return value;
              })(value["extraField3"]),
              firstName: ((value: string): unknown => {
                return value;
              })(value["firstName"]),
              frequency: ((value: "NONE" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"): unknown => {
                return value;
              })(value["frequency"]),
              function: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["function"]),
              language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                return value;
              })(value["language"]),
              lastName: ((value: string): unknown => {
                return value;
              })(value["lastName"]),
              password: ((value: string): unknown => {
                return value;
              })(value["password"]),
              ssoNameId: ((value: string): unknown => {
                return value;
              })(value["ssoNameId"]),
              termsAndConditions: ((value: boolean): unknown => {
                return value;
              })(value["termsAndConditions"]),
              title: ((value: bigint | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["title"]),
              town: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["town"]),
            };
          }
          case "B2B": {
            return {
              kind: "B2B",
              corporateId: ((value: bigint): unknown => {
                return value;
              })(value["corporateId"]),
              countryCode: ((value: string): unknown => {
                return value;
              })(value["countryCode"]),
              email: ((value: string): unknown => {
                return value;
              })(value["email"]),
              evrUuid: ((value: string): unknown => {
                return value;
              })(value["evrUuid"]),
              extraField1: ((value: string): unknown => {
                return value;
              })(value["extraField1"]),
              extraField2: ((value: string): unknown => {
                return value;
              })(value["extraField2"]),
              extraField3: ((value: string): unknown => {
                return value;
              })(value["extraField3"]),
              firstName: ((value: string): unknown => {
                return value;
              })(value["firstName"]),
              frequency: ((value: "NONE" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"): unknown => {
                return value;
              })(value["frequency"]),
              language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                return value;
              })(value["language"]),
              lastName: ((value: string): unknown => {
                return value;
              })(value["lastName"]),
              password: ((value: string): unknown => {
                return value;
              })(value["password"]),
              termsAndConditions: ((value: boolean): unknown => {
                return value;
              })(value["termsAndConditions"]),
            };
          }
          case "TRIAL": {
            return {
              kind: "TRIAL",
              corporateId: ((value: bigint): unknown => {
                return value;
              })(value["corporateId"]),
              countryCode: ((value: string): unknown => {
                return value;
              })(value["countryCode"]),
              email: ((value: string): unknown => {
                return value;
              })(value["email"]),
              evrUuid: ((value: string): unknown => {
                return value;
              })(value["evrUuid"]),
              firstName: ((value: string): unknown => {
                return value;
              })(value["firstName"]),
              frequency: ((value: "NONE" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"): unknown => {
                return value;
              })(value["frequency"]),
              language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                return value;
              })(value["language"]),
              lastName: ((value: string): unknown => {
                return value;
              })(value["lastName"]),
              password: ((value: string): unknown => {
                return value;
              })(value["password"]),
              termsAndConditions: ((value: boolean): unknown => {
                return value;
              })(value["termsAndConditions"]),
            };
          }
          case "B2C": {
            return {
              kind: "B2C",
              corporateId: ((value: bigint): unknown => {
                return value;
              })(value["corporateId"]),
              countryCode: ((value: string): unknown => {
                return value;
              })(value["countryCode"]),
              email: ((value: string): unknown => {
                return value;
              })(value["email"]),
              evrUuid: ((value: string): unknown => {
                return value;
              })(value["evrUuid"]),
              firstName: ((value: string): unknown => {
                return value;
              })(value["firstName"]),
              frequency: ((value: "NONE" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"): unknown => {
                return value;
              })(value["frequency"]),
              language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                return value;
              })(value["language"]),
              lastName: ((value: string): unknown => {
                return value;
              })(value["lastName"]),
              password: ((value: string): unknown => {
                return value;
              })(value["password"]),
              termsAndConditions: ((value: boolean): unknown => {
                return value;
              })(value["termsAndConditions"]),
            };
          }
        }
      })(value["either"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_WarmupEditForm(str: string): ParserResult<WarmupEditForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    either: WarmupEitherEditForm;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/WarmupEditForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/WarmupEditForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "either")) {
      return { success: false, reason: `[#/components/schemas/WarmupEditForm/either]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'either'.` };
    }
    const parsed_either = ((): ParserResult<WarmupEitherEditForm> => {
      return ((value: unknown): ParserResult<WarmupEitherEditForm> => {
        return ((
          value: unknown,
        ): ParserResult<
          | {
              kind: "SSO";
              corporateId: bigint;
              countryCode: string;
              email: string;
              evrUuid: string;
              extraField1: string;
              extraField2: string;
              extraField3: string;
              firstName: string;
              frequency: WeeklyEmailPushFrequency;
              function: string | null;
              language: Language;
              lastName: string;
              password: string;
              ssoNameId: string;
              termsAndConditions: boolean;
              title: bigint | null;
              town: string | null;
            }
          | {
              kind: "B2B";
              corporateId: bigint;
              countryCode: string;
              email: string;
              evrUuid: string;
              extraField1: string;
              extraField2: string;
              extraField3: string;
              firstName: string;
              frequency: WeeklyEmailPushFrequency;
              language: Language;
              lastName: string;
              password: string;
              termsAndConditions: boolean;
            }
          | {
              kind: "TRIAL";
              corporateId: bigint;
              countryCode: string;
              email: string;
              evrUuid: string;
              firstName: string;
              frequency: WeeklyEmailPushFrequency;
              language: Language;
              lastName: string;
              password: string;
              termsAndConditions: boolean;
            }
          | {
              kind: "B2C";
              corporateId: bigint;
              countryCode: string;
              email: string;
              evrUuid: string;
              firstName: string;
              frequency: WeeklyEmailPushFrequency;
              language: Language;
              lastName: string;
              password: string;
              termsAndConditions: boolean;
            }
        > => {
          return ((
            value: unknown,
          ): ParserResult<
            | {
                kind: "SSO";
                corporateId: bigint;
                countryCode: string;
                email: string;
                evrUuid: string;
                extraField1: string;
                extraField2: string;
                extraField3: string;
                firstName: string;
                frequency: WeeklyEmailPushFrequency;
                function: string | null;
                language: Language;
                lastName: string;
                password: string;
                ssoNameId: string;
                termsAndConditions: boolean;
                title: bigint | null;
                town: string | null;
              }
            | {
                kind: "B2B";
                corporateId: bigint;
                countryCode: string;
                email: string;
                evrUuid: string;
                extraField1: string;
                extraField2: string;
                extraField3: string;
                firstName: string;
                frequency: WeeklyEmailPushFrequency;
                language: Language;
                lastName: string;
                password: string;
                termsAndConditions: boolean;
              }
            | {
                kind: "TRIAL";
                corporateId: bigint;
                countryCode: string;
                email: string;
                evrUuid: string;
                firstName: string;
                frequency: WeeklyEmailPushFrequency;
                language: Language;
                lastName: string;
                password: string;
                termsAndConditions: boolean;
              }
            | {
                kind: "B2C";
                corporateId: bigint;
                countryCode: string;
                email: string;
                evrUuid: string;
                firstName: string;
                frequency: WeeklyEmailPushFrequency;
                language: Language;
                lastName: string;
                password: string;
                termsAndConditions: boolean;
              }
          > => {
            if (value == null) {
              return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm]: '${value}' expected to be non-null.` };
            }
            if (typeof value != "object") {
              return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm]: ${value} expected to be of type 'object'.` };
            }
            if (!hasProp(value, "kind")) {
              return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
            }
            if (typeof value["kind"] != "string") {
              return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm]: '${value["kind"]}' expected to be of type 'string'.` };
            }
            const discriminator = value["kind"];
            switch (discriminator) {
              case "SSO": {
                const parsedVariant = ((
                  value: unknown,
                ): ParserResult<{
                  corporateId: bigint;
                  countryCode: string;
                  email: string;
                  evrUuid: string;
                  extraField1: string;
                  extraField2: string;
                  extraField3: string;
                  firstName: string;
                  frequency: WeeklyEmailPushFrequency;
                  function: string | null;
                  language: Language;
                  lastName: string;
                  password: string;
                  ssoNameId: string;
                  termsAndConditions: boolean;
                  title: bigint | null;
                  town: string | null;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "corporateId")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
                  }
                  const parsed_corporateId = ((): ParserResult<bigint> => {
                    return ((value: unknown): ParserResult<bigint> => {
                      if (typeof value === "number") {
                        return { success: true, value: BigInt(value) };
                      }
                      if (typeof value === "bigint") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/corporateId]: '${value}' expected to be of type bigint or number.` };
                    })(value["corporateId"]);
                  })();
                  if (!parsed_corporateId.success) {
                    return { success: false, reason: parsed_corporateId.reason };
                  }
                  if (!hasProp(value, "countryCode")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/countryCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryCode'.` };
                  }
                  const parsed_countryCode = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/countryCode]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["countryCode"]);
                  })();
                  if (!parsed_countryCode.success) {
                    return { success: false, reason: parsed_countryCode.reason };
                  }
                  if (!hasProp(value, "email")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/email]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'email'.` };
                  }
                  const parsed_email = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/email]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["email"]);
                  })();
                  if (!parsed_email.success) {
                    return { success: false, reason: parsed_email.reason };
                  }
                  if (!hasProp(value, "evrUuid")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/evrUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'evrUuid'.` };
                  }
                  const parsed_evrUuid = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/evrUuid]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["evrUuid"]);
                  })();
                  if (!parsed_evrUuid.success) {
                    return { success: false, reason: parsed_evrUuid.reason };
                  }
                  if (!hasProp(value, "extraField1")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/extraField1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'extraField1'.` };
                  }
                  const parsed_extraField1 = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/extraField1]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["extraField1"]);
                  })();
                  if (!parsed_extraField1.success) {
                    return { success: false, reason: parsed_extraField1.reason };
                  }
                  if (!hasProp(value, "extraField2")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/extraField2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'extraField2'.` };
                  }
                  const parsed_extraField2 = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/extraField2]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["extraField2"]);
                  })();
                  if (!parsed_extraField2.success) {
                    return { success: false, reason: parsed_extraField2.reason };
                  }
                  if (!hasProp(value, "extraField3")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/extraField3]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'extraField3'.` };
                  }
                  const parsed_extraField3 = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/extraField3]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["extraField3"]);
                  })();
                  if (!parsed_extraField3.success) {
                    return { success: false, reason: parsed_extraField3.reason };
                  }
                  if (!hasProp(value, "firstName")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
                  }
                  const parsed_firstName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/firstName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["firstName"]);
                  })();
                  if (!parsed_firstName.success) {
                    return { success: false, reason: parsed_firstName.reason };
                  }
                  if (!hasProp(value, "frequency")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/frequency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'frequency'.` };
                  }
                  const parsed_frequency = ((): ParserResult<WeeklyEmailPushFrequency> => {
                    return ((value: unknown): ParserResult<WeeklyEmailPushFrequency> => {
                      return ((value: unknown): ParserResult<"NONE" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/WeeklyEmailPushFrequency]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "NONE":
                            return { success: true, value: "NONE" };
                          case "ONCE_A_WEEK":
                            return { success: true, value: "ONCE_A_WEEK" };
                          case "TWICE_A_MONTH":
                            return { success: true, value: "TWICE_A_MONTH" };
                          case "ONCE_A_MONTH":
                            return { success: true, value: "ONCE_A_MONTH" };
                          default:
                            return { success: false, reason: `[#/components/schemas/WeeklyEmailPushFrequency]: '${value}' expected to be enum, one of 'NONE, ONCE_A_WEEK, TWICE_A_MONTH, ONCE_A_MONTH'.` };
                        }
                      })(value);
                    })(value["frequency"]);
                  })();
                  if (!parsed_frequency.success) {
                    return { success: false, reason: parsed_frequency.reason };
                  }
                  if (!hasProp(value, "function")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/function]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'function'.` };
                  }
                  const parsed_function = ((): ParserResult<string | null> => {
                    return ((value: unknown): ParserResult<string | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/function]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["function"]);
                  })();
                  if (!parsed_function.success) {
                    return { success: false, reason: parsed_function.reason };
                  }
                  if (!hasProp(value, "language")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                  }
                  const parsed_language = ((): ParserResult<Language> => {
                    return ((value: unknown): ParserResult<Language> => {
                      return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "en":
                            return { success: true, value: "en" };
                          case "de":
                            return { success: true, value: "de" };
                          case "es":
                            return { success: true, value: "es" };
                          case "ru":
                            return { success: true, value: "ru" };
                          case "zh":
                            return { success: true, value: "zh" };
                          case "pt":
                            return { success: true, value: "pt" };
                          case "fr":
                            return { success: true, value: "fr" };
                          default:
                            return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                        }
                      })(value);
                    })(value["language"]);
                  })();
                  if (!parsed_language.success) {
                    return { success: false, reason: parsed_language.reason };
                  }
                  if (!hasProp(value, "lastName")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
                  }
                  const parsed_lastName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/lastName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["lastName"]);
                  })();
                  if (!parsed_lastName.success) {
                    return { success: false, reason: parsed_lastName.reason };
                  }
                  if (!hasProp(value, "password")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/password]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'password'.` };
                  }
                  const parsed_password = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/password]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["password"]);
                  })();
                  if (!parsed_password.success) {
                    return { success: false, reason: parsed_password.reason };
                  }
                  if (!hasProp(value, "ssoNameId")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/ssoNameId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ssoNameId'.` };
                  }
                  const parsed_ssoNameId = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/ssoNameId]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["ssoNameId"]);
                  })();
                  if (!parsed_ssoNameId.success) {
                    return { success: false, reason: parsed_ssoNameId.reason };
                  }
                  if (!hasProp(value, "termsAndConditions")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/termsAndConditions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'termsAndConditions'.` };
                  }
                  const parsed_termsAndConditions = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/termsAndConditions]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["termsAndConditions"]);
                  })();
                  if (!parsed_termsAndConditions.success) {
                    return { success: false, reason: parsed_termsAndConditions.reason };
                  }
                  if (!hasProp(value, "title")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                  }
                  const parsed_title = ((): ParserResult<bigint | null> => {
                    return ((value: unknown): ParserResult<bigint | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value === "number") {
                        return { success: true, value: BigInt(value) };
                      }
                      if (typeof value === "bigint") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/title]: '${value}' expected to be of type bigint or number.` };
                    })(value["title"]);
                  })();
                  if (!parsed_title.success) {
                    return { success: false, reason: parsed_title.reason };
                  }
                  if (!hasProp(value, "town")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/town]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'town'.` };
                  }
                  const parsed_town = ((): ParserResult<string | null> => {
                    return ((value: unknown): ParserResult<string | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/SSO/town]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["town"]);
                  })();
                  if (!parsed_town.success) {
                    return { success: false, reason: parsed_town.reason };
                  }
                  return {
                    success: true,
                    value: {
                      corporateId: parsed_corporateId.value,
                      countryCode: parsed_countryCode.value,
                      email: parsed_email.value,
                      evrUuid: parsed_evrUuid.value,
                      extraField1: parsed_extraField1.value,
                      extraField2: parsed_extraField2.value,
                      extraField3: parsed_extraField3.value,
                      firstName: parsed_firstName.value,
                      frequency: parsed_frequency.value,
                      function: parsed_function.value,
                      language: parsed_language.value,
                      lastName: parsed_lastName.value,
                      password: parsed_password.value,
                      ssoNameId: parsed_ssoNameId.value,
                      termsAndConditions: parsed_termsAndConditions.value,
                      title: parsed_title.value,
                      town: parsed_town.value,
                    },
                  };
                })(value);
                if (!parsedVariant.success) {
                  return { success: false, reason: parsedVariant.reason };
                }
                return { success: true, value: { kind: "SSO" as const, ...parsedVariant.value } };
              }
              case "B2B": {
                const parsedVariant = ((
                  value: unknown,
                ): ParserResult<{
                  corporateId: bigint;
                  countryCode: string;
                  email: string;
                  evrUuid: string;
                  extraField1: string;
                  extraField2: string;
                  extraField3: string;
                  firstName: string;
                  frequency: WeeklyEmailPushFrequency;
                  language: Language;
                  lastName: string;
                  password: string;
                  termsAndConditions: boolean;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "corporateId")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
                  }
                  const parsed_corporateId = ((): ParserResult<bigint> => {
                    return ((value: unknown): ParserResult<bigint> => {
                      if (typeof value === "number") {
                        return { success: true, value: BigInt(value) };
                      }
                      if (typeof value === "bigint") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/corporateId]: '${value}' expected to be of type bigint or number.` };
                    })(value["corporateId"]);
                  })();
                  if (!parsed_corporateId.success) {
                    return { success: false, reason: parsed_corporateId.reason };
                  }
                  if (!hasProp(value, "countryCode")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/countryCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryCode'.` };
                  }
                  const parsed_countryCode = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/countryCode]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["countryCode"]);
                  })();
                  if (!parsed_countryCode.success) {
                    return { success: false, reason: parsed_countryCode.reason };
                  }
                  if (!hasProp(value, "email")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/email]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'email'.` };
                  }
                  const parsed_email = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/email]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["email"]);
                  })();
                  if (!parsed_email.success) {
                    return { success: false, reason: parsed_email.reason };
                  }
                  if (!hasProp(value, "evrUuid")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/evrUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'evrUuid'.` };
                  }
                  const parsed_evrUuid = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/evrUuid]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["evrUuid"]);
                  })();
                  if (!parsed_evrUuid.success) {
                    return { success: false, reason: parsed_evrUuid.reason };
                  }
                  if (!hasProp(value, "extraField1")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/extraField1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'extraField1'.` };
                  }
                  const parsed_extraField1 = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/extraField1]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["extraField1"]);
                  })();
                  if (!parsed_extraField1.success) {
                    return { success: false, reason: parsed_extraField1.reason };
                  }
                  if (!hasProp(value, "extraField2")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/extraField2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'extraField2'.` };
                  }
                  const parsed_extraField2 = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/extraField2]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["extraField2"]);
                  })();
                  if (!parsed_extraField2.success) {
                    return { success: false, reason: parsed_extraField2.reason };
                  }
                  if (!hasProp(value, "extraField3")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/extraField3]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'extraField3'.` };
                  }
                  const parsed_extraField3 = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/extraField3]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["extraField3"]);
                  })();
                  if (!parsed_extraField3.success) {
                    return { success: false, reason: parsed_extraField3.reason };
                  }
                  if (!hasProp(value, "firstName")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
                  }
                  const parsed_firstName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/firstName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["firstName"]);
                  })();
                  if (!parsed_firstName.success) {
                    return { success: false, reason: parsed_firstName.reason };
                  }
                  if (!hasProp(value, "frequency")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/frequency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'frequency'.` };
                  }
                  const parsed_frequency = ((): ParserResult<WeeklyEmailPushFrequency> => {
                    return ((value: unknown): ParserResult<WeeklyEmailPushFrequency> => {
                      return ((value: unknown): ParserResult<"NONE" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/WeeklyEmailPushFrequency]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "NONE":
                            return { success: true, value: "NONE" };
                          case "ONCE_A_WEEK":
                            return { success: true, value: "ONCE_A_WEEK" };
                          case "TWICE_A_MONTH":
                            return { success: true, value: "TWICE_A_MONTH" };
                          case "ONCE_A_MONTH":
                            return { success: true, value: "ONCE_A_MONTH" };
                          default:
                            return { success: false, reason: `[#/components/schemas/WeeklyEmailPushFrequency]: '${value}' expected to be enum, one of 'NONE, ONCE_A_WEEK, TWICE_A_MONTH, ONCE_A_MONTH'.` };
                        }
                      })(value);
                    })(value["frequency"]);
                  })();
                  if (!parsed_frequency.success) {
                    return { success: false, reason: parsed_frequency.reason };
                  }
                  if (!hasProp(value, "language")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                  }
                  const parsed_language = ((): ParserResult<Language> => {
                    return ((value: unknown): ParserResult<Language> => {
                      return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "en":
                            return { success: true, value: "en" };
                          case "de":
                            return { success: true, value: "de" };
                          case "es":
                            return { success: true, value: "es" };
                          case "ru":
                            return { success: true, value: "ru" };
                          case "zh":
                            return { success: true, value: "zh" };
                          case "pt":
                            return { success: true, value: "pt" };
                          case "fr":
                            return { success: true, value: "fr" };
                          default:
                            return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                        }
                      })(value);
                    })(value["language"]);
                  })();
                  if (!parsed_language.success) {
                    return { success: false, reason: parsed_language.reason };
                  }
                  if (!hasProp(value, "lastName")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
                  }
                  const parsed_lastName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/lastName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["lastName"]);
                  })();
                  if (!parsed_lastName.success) {
                    return { success: false, reason: parsed_lastName.reason };
                  }
                  if (!hasProp(value, "password")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/password]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'password'.` };
                  }
                  const parsed_password = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/password]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["password"]);
                  })();
                  if (!parsed_password.success) {
                    return { success: false, reason: parsed_password.reason };
                  }
                  if (!hasProp(value, "termsAndConditions")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/termsAndConditions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'termsAndConditions'.` };
                  }
                  const parsed_termsAndConditions = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2B/termsAndConditions]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["termsAndConditions"]);
                  })();
                  if (!parsed_termsAndConditions.success) {
                    return { success: false, reason: parsed_termsAndConditions.reason };
                  }
                  return {
                    success: true,
                    value: {
                      corporateId: parsed_corporateId.value,
                      countryCode: parsed_countryCode.value,
                      email: parsed_email.value,
                      evrUuid: parsed_evrUuid.value,
                      extraField1: parsed_extraField1.value,
                      extraField2: parsed_extraField2.value,
                      extraField3: parsed_extraField3.value,
                      firstName: parsed_firstName.value,
                      frequency: parsed_frequency.value,
                      language: parsed_language.value,
                      lastName: parsed_lastName.value,
                      password: parsed_password.value,
                      termsAndConditions: parsed_termsAndConditions.value,
                    },
                  };
                })(value);
                if (!parsedVariant.success) {
                  return { success: false, reason: parsedVariant.reason };
                }
                return { success: true, value: { kind: "B2B" as const, ...parsedVariant.value } };
              }
              case "TRIAL": {
                const parsedVariant = ((
                  value: unknown,
                ): ParserResult<{
                  corporateId: bigint;
                  countryCode: string;
                  email: string;
                  evrUuid: string;
                  firstName: string;
                  frequency: WeeklyEmailPushFrequency;
                  language: Language;
                  lastName: string;
                  password: string;
                  termsAndConditions: boolean;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "corporateId")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
                  }
                  const parsed_corporateId = ((): ParserResult<bigint> => {
                    return ((value: unknown): ParserResult<bigint> => {
                      if (typeof value === "number") {
                        return { success: true, value: BigInt(value) };
                      }
                      if (typeof value === "bigint") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/corporateId]: '${value}' expected to be of type bigint or number.` };
                    })(value["corporateId"]);
                  })();
                  if (!parsed_corporateId.success) {
                    return { success: false, reason: parsed_corporateId.reason };
                  }
                  if (!hasProp(value, "countryCode")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/countryCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryCode'.` };
                  }
                  const parsed_countryCode = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/countryCode]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["countryCode"]);
                  })();
                  if (!parsed_countryCode.success) {
                    return { success: false, reason: parsed_countryCode.reason };
                  }
                  if (!hasProp(value, "email")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/email]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'email'.` };
                  }
                  const parsed_email = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/email]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["email"]);
                  })();
                  if (!parsed_email.success) {
                    return { success: false, reason: parsed_email.reason };
                  }
                  if (!hasProp(value, "evrUuid")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/evrUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'evrUuid'.` };
                  }
                  const parsed_evrUuid = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/evrUuid]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["evrUuid"]);
                  })();
                  if (!parsed_evrUuid.success) {
                    return { success: false, reason: parsed_evrUuid.reason };
                  }
                  if (!hasProp(value, "firstName")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
                  }
                  const parsed_firstName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/firstName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["firstName"]);
                  })();
                  if (!parsed_firstName.success) {
                    return { success: false, reason: parsed_firstName.reason };
                  }
                  if (!hasProp(value, "frequency")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/frequency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'frequency'.` };
                  }
                  const parsed_frequency = ((): ParserResult<WeeklyEmailPushFrequency> => {
                    return ((value: unknown): ParserResult<WeeklyEmailPushFrequency> => {
                      return ((value: unknown): ParserResult<"NONE" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/WeeklyEmailPushFrequency]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "NONE":
                            return { success: true, value: "NONE" };
                          case "ONCE_A_WEEK":
                            return { success: true, value: "ONCE_A_WEEK" };
                          case "TWICE_A_MONTH":
                            return { success: true, value: "TWICE_A_MONTH" };
                          case "ONCE_A_MONTH":
                            return { success: true, value: "ONCE_A_MONTH" };
                          default:
                            return { success: false, reason: `[#/components/schemas/WeeklyEmailPushFrequency]: '${value}' expected to be enum, one of 'NONE, ONCE_A_WEEK, TWICE_A_MONTH, ONCE_A_MONTH'.` };
                        }
                      })(value);
                    })(value["frequency"]);
                  })();
                  if (!parsed_frequency.success) {
                    return { success: false, reason: parsed_frequency.reason };
                  }
                  if (!hasProp(value, "language")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                  }
                  const parsed_language = ((): ParserResult<Language> => {
                    return ((value: unknown): ParserResult<Language> => {
                      return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "en":
                            return { success: true, value: "en" };
                          case "de":
                            return { success: true, value: "de" };
                          case "es":
                            return { success: true, value: "es" };
                          case "ru":
                            return { success: true, value: "ru" };
                          case "zh":
                            return { success: true, value: "zh" };
                          case "pt":
                            return { success: true, value: "pt" };
                          case "fr":
                            return { success: true, value: "fr" };
                          default:
                            return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                        }
                      })(value);
                    })(value["language"]);
                  })();
                  if (!parsed_language.success) {
                    return { success: false, reason: parsed_language.reason };
                  }
                  if (!hasProp(value, "lastName")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
                  }
                  const parsed_lastName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/lastName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["lastName"]);
                  })();
                  if (!parsed_lastName.success) {
                    return { success: false, reason: parsed_lastName.reason };
                  }
                  if (!hasProp(value, "password")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/password]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'password'.` };
                  }
                  const parsed_password = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/password]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["password"]);
                  })();
                  if (!parsed_password.success) {
                    return { success: false, reason: parsed_password.reason };
                  }
                  if (!hasProp(value, "termsAndConditions")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/termsAndConditions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'termsAndConditions'.` };
                  }
                  const parsed_termsAndConditions = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/TRIAL/termsAndConditions]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["termsAndConditions"]);
                  })();
                  if (!parsed_termsAndConditions.success) {
                    return { success: false, reason: parsed_termsAndConditions.reason };
                  }
                  return {
                    success: true,
                    value: {
                      corporateId: parsed_corporateId.value,
                      countryCode: parsed_countryCode.value,
                      email: parsed_email.value,
                      evrUuid: parsed_evrUuid.value,
                      firstName: parsed_firstName.value,
                      frequency: parsed_frequency.value,
                      language: parsed_language.value,
                      lastName: parsed_lastName.value,
                      password: parsed_password.value,
                      termsAndConditions: parsed_termsAndConditions.value,
                    },
                  };
                })(value);
                if (!parsedVariant.success) {
                  return { success: false, reason: parsedVariant.reason };
                }
                return { success: true, value: { kind: "TRIAL" as const, ...parsedVariant.value } };
              }
              case "B2C": {
                const parsedVariant = ((
                  value: unknown,
                ): ParserResult<{
                  corporateId: bigint;
                  countryCode: string;
                  email: string;
                  evrUuid: string;
                  firstName: string;
                  frequency: WeeklyEmailPushFrequency;
                  language: Language;
                  lastName: string;
                  password: string;
                  termsAndConditions: boolean;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "corporateId")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
                  }
                  const parsed_corporateId = ((): ParserResult<bigint> => {
                    return ((value: unknown): ParserResult<bigint> => {
                      if (typeof value === "number") {
                        return { success: true, value: BigInt(value) };
                      }
                      if (typeof value === "bigint") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/corporateId]: '${value}' expected to be of type bigint or number.` };
                    })(value["corporateId"]);
                  })();
                  if (!parsed_corporateId.success) {
                    return { success: false, reason: parsed_corporateId.reason };
                  }
                  if (!hasProp(value, "countryCode")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/countryCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryCode'.` };
                  }
                  const parsed_countryCode = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/countryCode]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["countryCode"]);
                  })();
                  if (!parsed_countryCode.success) {
                    return { success: false, reason: parsed_countryCode.reason };
                  }
                  if (!hasProp(value, "email")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/email]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'email'.` };
                  }
                  const parsed_email = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/email]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["email"]);
                  })();
                  if (!parsed_email.success) {
                    return { success: false, reason: parsed_email.reason };
                  }
                  if (!hasProp(value, "evrUuid")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/evrUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'evrUuid'.` };
                  }
                  const parsed_evrUuid = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/evrUuid]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["evrUuid"]);
                  })();
                  if (!parsed_evrUuid.success) {
                    return { success: false, reason: parsed_evrUuid.reason };
                  }
                  if (!hasProp(value, "firstName")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
                  }
                  const parsed_firstName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/firstName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["firstName"]);
                  })();
                  if (!parsed_firstName.success) {
                    return { success: false, reason: parsed_firstName.reason };
                  }
                  if (!hasProp(value, "frequency")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/frequency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'frequency'.` };
                  }
                  const parsed_frequency = ((): ParserResult<WeeklyEmailPushFrequency> => {
                    return ((value: unknown): ParserResult<WeeklyEmailPushFrequency> => {
                      return ((value: unknown): ParserResult<"NONE" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/WeeklyEmailPushFrequency]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "NONE":
                            return { success: true, value: "NONE" };
                          case "ONCE_A_WEEK":
                            return { success: true, value: "ONCE_A_WEEK" };
                          case "TWICE_A_MONTH":
                            return { success: true, value: "TWICE_A_MONTH" };
                          case "ONCE_A_MONTH":
                            return { success: true, value: "ONCE_A_MONTH" };
                          default:
                            return { success: false, reason: `[#/components/schemas/WeeklyEmailPushFrequency]: '${value}' expected to be enum, one of 'NONE, ONCE_A_WEEK, TWICE_A_MONTH, ONCE_A_MONTH'.` };
                        }
                      })(value);
                    })(value["frequency"]);
                  })();
                  if (!parsed_frequency.success) {
                    return { success: false, reason: parsed_frequency.reason };
                  }
                  if (!hasProp(value, "language")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
                  }
                  const parsed_language = ((): ParserResult<Language> => {
                    return ((value: unknown): ParserResult<Language> => {
                      return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "en":
                            return { success: true, value: "en" };
                          case "de":
                            return { success: true, value: "de" };
                          case "es":
                            return { success: true, value: "es" };
                          case "ru":
                            return { success: true, value: "ru" };
                          case "zh":
                            return { success: true, value: "zh" };
                          case "pt":
                            return { success: true, value: "pt" };
                          case "fr":
                            return { success: true, value: "fr" };
                          default:
                            return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                        }
                      })(value);
                    })(value["language"]);
                  })();
                  if (!parsed_language.success) {
                    return { success: false, reason: parsed_language.reason };
                  }
                  if (!hasProp(value, "lastName")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
                  }
                  const parsed_lastName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/lastName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["lastName"]);
                  })();
                  if (!parsed_lastName.success) {
                    return { success: false, reason: parsed_lastName.reason };
                  }
                  if (!hasProp(value, "password")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/password]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'password'.` };
                  }
                  const parsed_password = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/password]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["password"]);
                  })();
                  if (!parsed_password.success) {
                    return { success: false, reason: parsed_password.reason };
                  }
                  if (!hasProp(value, "termsAndConditions")) {
                    return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/termsAndConditions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'termsAndConditions'.` };
                  }
                  const parsed_termsAndConditions = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm/B2C/termsAndConditions]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["termsAndConditions"]);
                  })();
                  if (!parsed_termsAndConditions.success) {
                    return { success: false, reason: parsed_termsAndConditions.reason };
                  }
                  return {
                    success: true,
                    value: {
                      corporateId: parsed_corporateId.value,
                      countryCode: parsed_countryCode.value,
                      email: parsed_email.value,
                      evrUuid: parsed_evrUuid.value,
                      firstName: parsed_firstName.value,
                      frequency: parsed_frequency.value,
                      language: parsed_language.value,
                      lastName: parsed_lastName.value,
                      password: parsed_password.value,
                      termsAndConditions: parsed_termsAndConditions.value,
                    },
                  };
                })(value);
                if (!parsedVariant.success) {
                  return { success: false, reason: parsedVariant.reason };
                }
                return { success: true, value: { kind: "B2C" as const, ...parsedVariant.value } };
              }
              default:
                return { success: false, reason: `[#/components/schemas/WarmupEitherEditForm]: '${discriminator}' expected to be one of 'SSO, B2B, TRIAL, B2C'.` };
            }
          })(value);
        })(value);
      })(value["either"]);
    })();
    if (!parsed_either.success) {
      return { success: false, reason: parsed_either.reason };
    }
    return { success: true, value: { either: parsed_either.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
